import deepmerge from 'deepmerge'

import { getPersistedState } from '@/logic/statePersisting'

const defaultState = {
  lastServiceWorkerUpdate: null,
  appMobileInstallationBlockHiddenAt: null,
}

const persistedState = getPersistedState('internal')

export default deepmerge(defaultState, persistedState)
